import { animate, AnimationMetadata, group, keyframes, state, style, transition } from '@angular/animations';
import { easing } from '.';

export const bottomNavigationAnimation: AnimationMetadata[] = [
  state('true', style({ transform: 'translateY(-32px)', opacity: 1 })),
  state('false', style({ transform: 'translateY(0)', opacity: 1 })),
  transition(
    'true => false',
    group([
      //zIndex animations
      // at half of animation zIndex will be swapped
      // zIndex is not animatable but we can use this to appear/dissapear behind the svg background
      // opacity does the rest of the magic
      animate(
        '1000ms',
        keyframes([
          style({ zIndex: -1, offset: 0 }),
          style({ zIndex: -1, offset: 0.5 }),
          style({ zIndex: 1, offset: 0.625 }),
        ])
      ),
      //opacity animation
      animate(
        '1000ms',
        keyframes([
          style({ opacity: 1, offset: 0 }),
          style({ opacity: 1, offset: 0.125 }),
          style({ opacity: 0, offset: 0.25 }),
          style({ opacity: 0, offset: 0.5 }),
          style({ opacity: 0, offset: 0.625 }),
          style({ opacity: 1, offset: 0.75 }),
        ])
      ),
      //transform
      animate(`375ms ${easing.easeInOutBack}`, style({ transform: 'translateY(0)' })),
    ])
  ),
  transition(
    'false => true',
    group([
      //zIndex animations
      // at half of animation zIndex will be swapped
      // zIndex is not animatable but we can use this to appear/dissapear behind the svg background
      // opacity does the rest of the magic
      animate(
        '1000ms',
        keyframes([
          style({ zIndex: 1, offset: 0 }),
          style({ zIndex: 1, offset: 0.5 }),
          style({ zIndex: -1, offset: 0.75 }),
        ])
      ),
      //opacity animation
      animate(
        '1000ms',
        keyframes([
          style({ opacity: 1, offset: 0 }),
          style({ opacity: 1, offset: 0.375 }),
          style({ opacity: 0, offset: 0.5 }),
          style({ opacity: 0, offset: 0.75 }),
          style({ opacity: 1, offset: 0.76 }),
        ])
      ),
      //transform
      animate(`375ms 375ms ${easing.easeInOutBack}`, style({ transform: 'translateY(-32px)' })),
    ])
  ),
];
